import { PageHeader, Card } from './Card';

const Placeholder = ({ title }: { title: string }) => (
  <>
    <PageHeader title={title} />
    <Card>
      <p className="text-sm text-gray-500 dark:text-gray-400">Écran en cours de migration…</p>
    </Card>
  </>
);

export default Placeholder;
